import { OutlinedInput, withStyles } from '@material-ui/core';
const StyledOutlinedInput = withStyles({
    root: {
        borderRadius: '0.5rem'
    },
    marginDense: {
        marginTop: '1rem'
    }
})(OutlinedInput);
export default StyledOutlinedInput;